import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITerminalService = ( createDecorator('terminalService'));
const ITerminalConfigurationService = ( createDecorator('terminalConfigurationService'));
const ITerminalEditorService = ( createDecorator('terminalEditorService'));
const ITerminalGroupService = ( createDecorator('terminalGroupService'));
const ITerminalInstanceService = ( createDecorator('terminalInstanceService'));
export { ITerminalConfigurationService, ITerminalEditorService, ITerminalGroupService, ITerminalInstanceService, ITerminalService };
